import './simple_header_login.js';
import './oidc.js'; // for myStuff login
import './DragDropTouch';
import './suburbs.js';
import * as Criteria from './criteria.js';
import * as Report from './report.js';
import { fetchText } from './utils';
import './footer.js';

let optionList = document.querySelector('#ss-optionList');

window.json_cb = Report.json_cb;

const readmoreURL = "https://interactives.stuff.co.nz/sweet-spots/static/readmore.html";
const readmoreTarget = document.querySelector('.ssrm-links');


const init = () => {
  Criteria.optionArray.forEach((option, i) => {
    let newItem = document.createElement('li');

    newItem.classList.add('criteriaOption');
    newItem.dataset.opnum = i;
    newItem.innerHTML = `<svg class="sidepin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.89 51.28"><defs><style>.b{fill:#c6f7e2;}</style></defs><path class="b" d="M7.51,7.51h0c-10.01,10.01-10.01,26.25,0,36.26h0c10.01,10.01,26.25,10.01,36.26,0l18.13-18.13L43.77,7.51C33.75-2.5,17.52-2.5,7.51,7.51Z"/></svg><input type="checkbox"> ${option.text}`;

    newItem.addEventListener('click', Criteria.selectCriteria)
    optionList.appendChild(newItem);

  });
}

Criteria.sendBtn.addEventListener('click', () => {
    let dataStr = Criteria.compileData();
  //console.log(dataStr);
  Report.submitData(dataStr);
  }
);

init();
fetchText(readmoreURL, readmoreTarget);
